// @ts-nocheck

import {IMoney} from "./interface";

export class UUID {
    constructor(uuid) {
        this._sdkType = this.constructor._sdkType;
        this.uuid = uuid;
    }
}
UUID._sdkType = 'UUID';

export class Money implements IMoney {
    constructor(amount: number, currency: string) {
        this._sdkType = this.constructor._sdkType;
        this.amount = amount;
        this.currency = currency;
    }
}
Money._sdkType = 'Money';
